import * as React from "react";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { Checkbox, FormControlLabel, FormHelperText } from "@mui/material";

export default function UiCheckboxInput(props) {
  const {
    label,
    value,
    name,
    defaultValue,
    type,
    onChange,
    error,
    placeholder,
    multiline,
    maxRows,
    minRows,
    onInput,
    inputonChange,
    readOnly,
    helperText,
    customInputProps,
    inputIcon,
    accept,
    enableStrength,
    enableConditions,
    groupLabel,
  } = props;

  const className = `df-radio ${
    props.className ? props.className : "df-radio"
  }`;

  return (
    <FormControl className="df-checkbox">
      {groupLabel && (
        <FormLabel id="demo-radio-buttons-group-label">{groupLabel}</FormLabel>
      )}

      <FormControlLabel
        control={
          <Checkbox
            {...props}
            aria-labelledby="df-radio-buttons-group-label"
            name={name}
            className={className}
            error={error}
            onChange={onChange}
            value={value}
          />
        }
        label={props.label}
      />

      {error && (
        <FormHelperText className="component-error-text">
          {error}
        </FormHelperText>
      )}
    </FormControl>
  );
}
